import { useQuery } from 'react-query';

import Api from '../../api/api';

export type GetSuggestedSubCategoryDto = {
  page?: number;
  limit?: number;
  sort?: string;
  search?: string;
};

const getSuggestedSubCategory = async (params: GetSuggestedSubCategoryDto) => {
  const [response, bodyOrError] = await Api.get(`sub-categories/suggested`, params);

  if (!response?.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

const useGetSuggestedSubCategory = (params: GetSuggestedSubCategoryDto) => {
  return useQuery({
    queryKey: ['suggestedSubCategories', params],
    queryFn: () => getSuggestedSubCategory(params),
    initialData: { total: 0, data: [], page: 0, limit: 0 },
  });
};
export default useGetSuggestedSubCategory;
